import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";

function pushAd() {
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch(_) {};
}

function ins(props) {
    return createElement("ins", createObj(props));
}

/**
 * Reusable AdSense ad slot component.
 * adSlotId: the data-ad-slot value from your AdSense account.
 * adFormat: ad format string, e.g. "auto", "horizontal", "rectangle".
 * cssClass: optional extra CSS class for the wrapper div.
 */
export function AdSlot(adSlotInputProps) {
    let elems;
    const cssClass = adSlotInputProps.cssClass;
    const adFormat = adSlotInputProps.adFormat;
    const adSlotId = adSlotInputProps.adSlotId;
    const dependencies = [adSlotId];
    reactApi.useEffect(() => {
        pushAd();
    }, dependencies);
    return createElement("div", createObj(ofArray([["className", "ad-slot-container" + ((cssClass === "") ? "" : (" " + cssClass))], (elems = [ins(ofArray([["className", "adsbygoogle"], ["style", {
        display: "block",
    }], ["data-ad-client", "ca-pub-XXXXXXXXXX"], ["data-ad-slot", adSlotId], ["data-ad-format", adFormat], ["data-full-width-responsive", "true"]]))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

